"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Button = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = require("rebass/styled-components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Button = function Button(props) {
  var variant = 'primary';

  if (props.hollow == true) {
    variant = 'hollow';
  }

  if (props.inverted == true) {
    variant = 'inverted';
  }

  if (props.disabled == true) {
    variant += '-disabled';
  }

  if (props.variant !== undefined) {
    variant = props.variant;
  }

  return _react.default.createElement(_styledComponents.Button, _extends({}, props, {
    variant: variant,
    sx: {
      borderWidth: props.border
    }
  }));
};

exports.Button = Button;
Button.propTypes = {
  fontSize: _propTypes.default.number,
  inverted: _propTypes.default.bool,
  hollow: _propTypes.default.bool,
  border: _propTypes.default.number,
  variant: _propTypes.default.string
};
Button.defaultProps = {
  fontSize: 1,
  border: 2
};
var _default = Button;
exports.default = _default;